import React from "react";

import { Modal } from "react-bootstrap";
import FormValidate from "../Form/validateUser";

export const  ModalAdvanceStatus = ({show, handleClose}) => {
    return <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                <FormValidate handleClose={handleClose} />
            </Modal.Body>
        </Modal>
}

